const isObject = (val) => typeof val === 'object';

const lvlColorMap = {
  log: '#59aaff',
  info: '#29c3e0',
  warn: '#ffcc2b',
  error: '#f37f89',
};

export default {
  base(level, msg) {
    if (process.env.NODE_ENV !== 'pro') {
      const m = new Date();
      const dateString = `${m.getFullYear()}-${
        (`0${m.getMonth() + 1}`).slice(-2)}-${
        (`0${m.getDate()}`).slice(-2)} ${
        (`0${m.getHours()}`).slice(-2)}:${
        (`0${m.getMinutes()}`).slice(-2)}:${
        (`0${m.getSeconds()}`).slice(-2)}`;

      const message = isObject(msg) ? msg.message : msg;
      // eslint-disable-next-line no-console
      console.log(
        `%c${level.toUpperCase()}%c[${dateString}]%c${message}`,
        `color:${lvlColorMap[level]};background:#000;padding: 1px 4px;`,
        'color:#0f9a9e',
        'color:#666',
      );
    }
  },
  log(msg) {
    this.base('log', msg);
  },
  info(msg) {
    this.base('info', msg);
  },
  warn(msg) {
    this.base('warn', msg);
  },
  error(msg) {
    this.base('error', msg);
  },
};
